import { LogManager } from '../../../common';
import { WorkingHoursByRangeDistibutionAggregateRootMapper } from '../../../infrastructure/mappers/working-hours/working-hours-by-range-distribution.mapper';
import { WorkingHoursByRangeDistributionRequestDto } from '../../dtos/working-hours/working-hours-by-range-distribution.request.dto';
import { WorkingHoursByRangeDistributionResponseDto } from '../../dtos/working-hours/working-hours-by-range-distribution.response.dto';
import { WorkingHoursByRangeDistributionQuery } from '../../queries/working-hours/working-hours-by-range-distribution.query';

export class WorkingHoursByRangeDistributionController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: WorkingHoursByRangeDistributionQuery,
    protected readonly mapper: WorkingHoursByRangeDistibutionAggregateRootMapper
  ) {}

  async get(
    props: WorkingHoursByRangeDistributionRequestDto
  ): Promise<WorkingHoursByRangeDistributionResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `WorkingHoursByRangeDistributionController.get encountered an error ${error}`
      );
    }
  }
}
